import { combineReducers } from "@reduxjs/toolkit";

// Reducers
import { viewsAdminUsersTableReducer } from "./users/tableReducer";

export const viewsAdminUsersReducer = combineReducers({
  table: viewsAdminUsersTableReducer,
});